module.exports = __webpack_public_path__ + "img/s-weight.b9e6fa04.svg";